/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Header_tradeNavigation = {|
  +modules: ?$ReadOnlyArray<?{|
    +serviceId: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_tradeNavigation",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BottomBar_navigation",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "NavigationModule",
      "name": "modules",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Navigation"
};

module.exports = fragment;
